// @flow
import React from 'react';
import { FLINK_POOL_RESOURCE_INPUTS_DETAILS_CONFIG_MAP } from '@streaming-projects/resource-definitions/flink-resource-definitions/flink-resource-inputs-config';
import { FLINK_POOL_RESOURCES_GRID_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { TextField } from '@src/formik-utils/FormFields';

export const FlinkPoolResourceNameContainer = ({
  disabled,
  disableOnFormErrors = null,
  fluid = null,
}) => {
  const { backendFieldName, displayName, icon } = FLINK_POOL_RESOURCE_INPUTS_DETAILS_CONFIG_MAP.get(
    FLINK_POOL_RESOURCES_GRID_FIELDNAMES.NAME
  );
  return (
    <TextField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      fluid={fluid}
      icon={icon}
    />
  );
};
